import { useCallback, useSyncExternalStore } from "react";
import type { ApiTag } from "@webcore/services/api/api";
import { getDataChangeVersion, subscribeToDataChangeVersions } from "@webcore/services/signalr/dataChangeVersions";

/**
 * Re-renders the caller whenever a data-change notification invalidates `tag`, returning how many
 * invalidations have been seen for it. For code that lives outside the RTK Query cache and so cannot
 * be refreshed by invalidating a tag — a custom dashboard view fetching KPI data imperatively, for
 * example — this is the signal that the underlying data moved.
 */
export function useDataChangeVersion(tag: ApiTag): number {
  const getSnapshot = useCallback(() => getDataChangeVersion(tag), [tag]);
  return useSyncExternalStore(subscribeToDataChangeVersions, getSnapshot, getSnapshot);
}
